import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../mock/mockData';
import { useLanguage } from '../translations/LanguageContext';
import { Card } from './ui/card';
import { Clock, CheckCircle2, ArrowRight } from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();
  
  // Map service IDs to translation keys
  const serviceTranslations = {
    'acupuncture': t.services.acupuncture,
    'aculifting': t.services.aculifting,
    'korean-relaxation': t.services.koreanRelaxation
  };

  return (
    <section id="services" className="py-20 px-4 bg-section">
      <div className="container max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">{t.services.title}</h2>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => {
            const translation = serviceTranslations[service.id];
            return (
              <Card key={service.id} className="product-card group flex flex-col">
                <div className="relative overflow-hidden rounded-lg mb-6">
                  <img 
                    src={service.image} 
                    alt={translation.name}
                    className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
                    style={service.id === 'korean-relaxation' ? { objectPosition: '30% center' } : {}}
                  />
                </div>
                
                <h3 className="product-card-title mb-3">{translation.name}</h3>
                <p className="product-card-description mb-4">{translation.shortDesc}</p>
                
                <div className="flex items-center gap-4 mb-4 text-sm">
                  <div className="flex items-center gap-1 text-accent-text font-semibold">
                    <Clock size={16} />
                    <span>{service.duration}</span>
                  </div>
                  <div className="flex items-center gap-1 text-muted">
                    <span>{service.price}</span>
                  </div>
                </div>

                <div className="border-t border-light pt-4 mb-6">
                  <p className="body-small font-semibold mb-2">{t.common.benefits}</p>
                  <ul className="space-y-1">
                    {translation.benefits.slice(0, 3).map((benefit, idx) => (
                      <li key={idx} className="flex items-start gap-2 body-small">
                        <CheckCircle2 size={14} className="text-accent-primary mt-1 flex-shrink-0" />
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Link 
                  to={`/services/${service.id}`}
                  className="btn-secondary mt-auto flex items-center justify-center gap-2 group-hover:bg-accent-wash"
                >
                  {t.services.learnMore}
                  <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                </Link>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
